import React from 'react';

import { ErrorModal } from '../../components/ErrorModal/ErrorModal';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { GlobalMessages } from '../../types/Messages';

export const hooks = {
  useErrors() {
    const apiErrorModal = messageHooks.useSubjectState(GlobalMessages.APIErrorModal);
    const resetAPIErrorModal = messageHooks.useNextWithValue(GlobalMessages.APIErrorModal, null);

    return {
      apiErrorModal,
      resetAPIErrorModal,
    };
  },
};

export const ErrorModalConatiner = () => {
  const {
    apiErrorModal,
    resetAPIErrorModal,
  } = hooks.useErrors();

  return (
    apiErrorModal && <ErrorModal
      apiError={apiErrorModal}
      onCloseModal={resetAPIErrorModal}
    />
  );
};

ErrorModalConatiner.displayName = 'ErrorModalConatiner';
